import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {UPLOAD_QUIZ, UPLOAD_QUIZ_API_URL, GET_ALL_UPLOAD_QUIZ_API_URL} from 'constants/AppConstants';
import { USER_All_INFORMATION } from "constants/AuthConstant";
import CommonService from 'services/CommonService/CommonService';
import IntlMessage from "components/util-components/IntlMessage";
const setLocale = (localeKey, isLocaleOn = true) =>
  isLocaleOn ? <IntlMessage id={localeKey} /> : localeKey.toString();
const permission = JSON.parse(localStorage.getItem(USER_All_INFORMATION));

export const initialState = {
  UploadQuizErrors       : {},
  permission: permission?.upload_quiz ?? [],
  UploadQuizShowMessage  : null,
  UploadQuizResult       : [],
  UploadQuizButtonSpinner : false,
  UploadQuizTableLoading : true,
  UploadQuizAddDrawer    : false,
  UploadQuizEditData     : [],
  UploadQuizButtonAndModelLabel  : setLocale('uploadquiz.add'),
  tablePagination: {
        current: 1,
        pageSize: 10,
        total: 0,
    },
    sorting: {},
    filter: {},
    ViewUploadQuizData: [],
    ViewUploadQuizLoader: true,
    DrawerStatus: 0,
};

export const createUploadQuiz = createAsyncThunk(
    "createUploadQuiz",
  async (data) => {
    try {
      const response = await CommonService.createAndUpdate(data, UPLOAD_QUIZ_API_URL);
      return response;
    } catch (err) {
      const errors = err.response?.data?.errors;
      const message = err.response?.data?.message || "Unable to create quiz.";
      throw new Error(JSON.stringify(errors || { general: message })); // Throw an error with the server response errors
    }
  }
);

export const getUploadQuiz = createAsyncThunk(
    "getUploadQuiz",
  async (data) => {
    try {
      const response = await CommonService.getAllPost(data, GET_ALL_UPLOAD_QUIZ_API_URL);
      return response;
    } catch (err) {
      throw new Error(JSON.stringify(err.response.data.errors)); // Throw an error with the server response errors
    }
  }
);

export const viewUploadQuiz = createAsyncThunk(
  "viewUploadQuiz",
  async (id) => {
    try {
      const response = await CommonService.showOne(id, UPLOAD_QUIZ_API_URL);
      return response;
    } catch (err) {
      throw new Error(JSON.stringify(err.response.data.errors)); // Throw an error with the server response errors
    }
  }
);

export const deleteUploadQuiz = createAsyncThunk(
  "deleteUploadQuiz",
  async (data) => {
    try {
      const response = await CommonService.deleteOne(data, UPLOAD_QUIZ_API_URL);
      return response;
    } catch (err) {
      throw new Error(JSON.stringify(err.response.data.errors)); // Throw an error with the server response errors
    }
  }
);

export const manageUploadQuizSlice = createSlice({
  name: UPLOAD_QUIZ,
  initialState,
  reducers: {
    onCloseError: (state, action) => {
      state.UploadQuizErrors = {};
    },
    UploadQuizAddDrawerStatus: (state, action) => {
        if (action.payload.status === false) {
            state.UploadQuizButtonSpinner = false;
      }
      state.UploadQuizAddDrawer   = action.payload.status;
      state.DrawerStatus = action.payload.errorStatus;
      state.UploadQuizEditData    = [];
      state.UploadQuizButtonAndModelLabel = setLocale('uploadquiz.add');
    },
    UploadQuizEditWithDrawerStatus: (state, action) => {
      state.UploadQuizAddDrawer = true;
      state.DrawerStatus = action.payload.errorStatus;
      state.UploadQuizEditData = action.payload.data;
      state.UploadQuizButtonAndModelLabel = setLocale('uploadquiz.edit');
    },
    updateSortFilters: (state, action) => {
        state.filter = action.payload.filter;
        state.sorting = action.payload.sorting;
    },
    setColumnSearch: (state, action) => {
      state.filter = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createUploadQuiz.pending, (state, action) => {
        state.DrawerStatus = 0
        state.UploadQuizButtonSpinner = true;
      }).addCase(createUploadQuiz.fulfilled, (state, action) => {
        state.DrawerStatus = 0
        state.UploadQuizButtonSpinner = false;
        state.UploadQuizErrors = {}
      }).addCase(createUploadQuiz.rejected, (state, action) => {
        state.DrawerStatus = 1
        state.UploadQuizShowMessage = true;
        state.UploadQuizButtonSpinner = false;
        state.UploadQuizErrors = JSON.parse(action.error.message); // Parse the error messages and store them in the state
      }).addCase(getUploadQuiz.pending, (state, action) => {
        state.UploadQuizButtonSpinner = true;
        state.UploadQuizTableLoading = true;
      }).addCase(getUploadQuiz.fulfilled, (state, action) => {
        state.UploadQuizButtonSpinner = false;
        state.UploadQuizTableLoading = false;
        state.UploadQuizResult = action.payload;
        state.tablePagination = {
            ...state.tablePagination,
            total: action.payload.pagination.total,
            current: action.payload.pagination.current_page,
            pageSize: action.payload.pagination.per_page
        };
      }).addCase(getUploadQuiz.rejected, (state, action) => {
        state.UploadQuizShowMessage = true; // Set the showMessage flag to display the errors
        state.UploadQuizButtonSpinner = false;
        state.UploadQuizTableLoading = false;
        state.UploadQuizErrors = JSON.parse(action.error.message); // Parse the error messages and store them in the state
      })
      .addCase(viewUploadQuiz.pending, (state, action) => {
        state.ViewUploadQuizLoader = true;
        state.ViewUploadQuizData = [];
      }).addCase(viewUploadQuiz.fulfilled, (state, action) => {
        state.ViewUploadQuizLoader = false;
        state.ViewUploadQuizData = action.payload;
      }).addCase(viewUploadQuiz.rejected, (state, action) => {
        state.ViewUploadQuizLoader = false;
        state.ViewUploadQuizData = [];
      })
      .addCase(deleteUploadQuiz.pending, (state, action) => {
        state.UploadQuizTableLoading = true;
      }).addCase(deleteUploadQuiz.fulfilled, (state, action) => {
        state.UploadQuizTableLoading = false;
      }).addCase(deleteUploadQuiz.rejected, (state, action) => {
        state.UploadQuizTableLoading = false;
      });
  },
});

export const { onCloseError, setColumnSearch, UploadQuizAddDrawerStatus, UploadQuizEditWithDrawerStatus, updateSortFilters } = manageUploadQuizSlice.actions;

export default manageUploadQuizSlice.reducer;
